import {computed, observable} from "mobx";
import {MobXHelper, VarHelper} from "common-import/helpers";
import api from "./Contractor.API";

const { makePersit } = MobXHelper;

const PERSIST_STORE_ITEM = {
  
};

class ContractorStore {
  @observable listAll = [];

  @observable listApproved = [];

  @observable listNotApproved = [];

  @observable currentContractor = {};

  @computed get allListContractor() {
    return [...this.listApproved, ...this.listNotApproved];
  }

  setProp = (prop, value) => { this[prop] = value  };

  getAll = async (page) => {
    let res = await api.adminList({
      "orderBy": "updatedAt",
      "orderType": "DESC",
      "page": page || 1
    });
    let json = await res.json();
    if (!!json.error) return { status: false, error: json.error };
    this.listAll = json.data;
    return { status: true };
  };
  
  getListApproved = async (page) => {
    let res = await api.adminList({
      "orderBy": "updatedAt",
	    "orderType": "DESC",
      "approved": 1,
      "page": page || 1
    });
    let json = await res.json();
    if (!!json.error) return { status: false, error: json.error };
    this.listApproved = json.data;
    return { status: true };
  };

  getListNotApproved = async (page) => {
    let res = await api.adminList({
      "orderBy": "updatedAt",
	    "orderType": "DESC",
      "approved": 0,
      "page": page || 1
    });
    let json = await res.json();
    if (!!json.error) return { status: false, error: json.error };
    this.listNotApproved = json.data;
    return { status: true };
  };

  getListNotApprovedUpdate = async (page) => {
    let res = await api.adminList({
      "orderBy": "updatedAt",
	    "orderType": "DESC",
      "approved": 3,
      "page": page || 1
    });
    let json = await res.json();
    if (!!json.error) return { status: false, error: json.error };
    this.listNotApproved = json.data;
    return { status: true };
  };

  simpleSearch = async ({name, taxCode}) => {
    let res = await api.adminList(VarHelper.filterEmptyObjProp({
      "name": name,
      "orderBy": "updatedAt",
	    "orderType": "DESC",
	    "taxCode": taxCode
    }));
    let json = await res.json();
    return json;
  }

  search = async (name, approved) => {
    let res = await api.adminList({
      "name": name,
      "orderBy": "updatedAt",
	    "orderType": "DESC",
	    "approved": approved
    });
    let json = await res.json();
    if (!!json.error) return { status: false, error: json.error };

    switch (approved) {
      case undefined: this.listAll = json.data; break;
      case 1: this.listApproved = json.data; break;
      case 0: this.listNotApproved = json.data; break;
      case 3: this.listNotApproved = json.data; break;
    }
    return { status: true, data: json.data };
  };

  update = async (data, id = null) => {
    if (!id) return;
    const res = await api.update(id, data);
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  create = async data => {
    let res = await api.create(data);
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  approve = async ({id, approved}) => {
    let res = await api.approve({id, approved: approved ? 1 : 0});
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  deactive = async (id) => {
    let res = await api.deactive({id});
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  detail = async (id) => {
    if (!id) return;
    const res = await api.detail(id);
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  updateHouseLink = async (data) => {
    const res = await api.updateHouseLink(data);
    if (!!res.validateError) {
      return { error: res.validateError }
    }
    return await res.json();
  };

  searchByName = async ({name}) => {
    let res = await api.search({
      "name": name,
      "orderBy": "updatedAt",
      "orderType": "DESC",
    });
    return await res.json();
  }

  importOldSystem = async (id) => {
    let res = await api.importOldSystem(id);
    return await res.json();
  }

  searchByOldId = async (id) => {
    let res = await api.searchByOldId(id);
    return await res.json();
  }
}

const contractorStore = new ContractorStore();

export default contractorStore;



// WEBPACK FOOTER //
// ./src/services/contractor/Contractor.Store.js